import BaseModel from './BaseModel'

export default class Department extends BaseModel {
  // ... DEpartment-specific methods or overrides ...
}
